// Cookies e click ids de anúncio do comprador (_ga, _ga_<ID>, _ttp, ttclid, gclid...) para os
// eventos server-side da API. Fica separado do adsUserData.js para o store (bundle principal)
// não carregar o crypto-js.

function readCookies() {
    if (typeof document === 'undefined' || !document.cookie) {
        return {}
    }
    return document.cookie.split(';').reduce((cookies, pair) => {
        const index = pair.indexOf('=')
        if (index > 0) {
            const name = pair.slice(0, index).trim()
            try {
                cookies[name] = decodeURIComponent(pair.slice(index + 1).trim())
            } catch (e) {
                cookies[name] = pair.slice(index + 1).trim()
            }
        }
        return cookies
    }, {})
}

const CLICK_ID_PARAMS = ['ttclid', 'gclid', 'gbraid', 'wbraid']
const CLICK_ID_TTL_MS = 28 * 24 * 60 * 60 * 1000

function rememberClickIds() {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return
    }
    let params
    try {
        params = new URLSearchParams(window.location.search)
    } catch (e) {
        return
    }
    CLICK_ID_PARAMS.forEach((param) => {
        const value = params.get(param)
        if (value) {
            // Sem truncar e sem mudar maiúsculas (gbraid/ttclid são sensíveis a isso).
            localStorage.setItem(`unico_${param}`, JSON.stringify({ value, at: Date.now() }))
        }
    })
}

function storedClickId(param) {
    try {
        const stored = JSON.parse(localStorage.getItem(`unico_${param}`) || 'null')
        if (stored && stored.value && Date.now() - stored.at < CLICK_ID_TTL_MS) {
            return stored.value
        }
    } catch (e) {
        // valor corrompido: ignora
    }
    return ''
}

// Cookies do vinculador de conversões do gtag no domínio do checkout: "GCL.<timestamp>.<click id>".
const GCL_COOKIES = { gclid: '_gcl_aw', gbraid: '_gcl_gb' }

function clickIdFromGclCookie(value) {
    const parts = String(value || '').split('.')
    return parts.length >= 3 && parts[0] === 'GCL' ? parts.slice(2).join('.') : ''
}

// URL atual ou de uma visita dos últimos 28 dias; depois os cookies do ttq/gtag.
function clickId(param, cookies) {
    return storedClickId(param)
        || (param === 'ttclid' ? cookies.ttclid || '' : '')
        || (GCL_COOKIES[param] ? clickIdFromGclCookie(cookies[GCL_COOKIES[param]]) : '')
}

/**
 * Cookies e click ids que a API usa nos eventos server-side (TikTok ttp/ttclid, GA4 client_id e
 * session_id, gclid). Vão em extra_data.ad_ids de cada evento do tracker; a API lê do
 * TrackerEvent mais recente do cliente (BuildsPixelPurchaseData::trackerAdIds).
 */
export function collectAdIds() {
    rememberClickIds()
    const cookies = readCookies()
    const adIds = {}

    Object.keys(cookies).forEach((name) => {
        if (name === '_ga' || name.startsWith('_ga_') || name === '_ttp') {
            adIds[name] = cookies[name]
        }
    })

    CLICK_ID_PARAMS.forEach((param) => {
        const value = clickId(param, cookies)
        if (value) {
            adIds[param] = value
        }
    })

    return adIds
}

/**
 * Click ids do Google gravados no pedido junto de src/utm_* (tracking do /requestPayment), para o
 * lojista atribuir a venda e para a conversão offline do Google Ads.
 */
export function collectGoogleClickIds() {
    rememberClickIds()
    const cookies = readCookies()

    return {
        gclid: clickId('gclid', cookies),
        gbraid: clickId('gbraid', cookies),
        wbraid: clickId('wbraid', cookies),
    }
}
